import React, { useEffect, useState, createRef }  from 'react';
import { Link } from 'react-router-dom';
import { ListGroup, Dropdown } from 'react-bootstrap';
import { capitalize, convertdatenotime } from './utils';
import { postData, deleteData, putData } from './Api';
import { BsPlus } from 'react-icons/bs';
import ModalItem from './Modal';
import { color } from 'framer-motion';

const ItemListSpaces = ({ data, cols, baseUrl, setData, fields }) => {

    const [selectedItem, setSelectedItem] = useState({});
    const [showAddItemModal, setShowAddItemModal] = useState(false);
    const [showUpdateItemModal, setShowUpdateItemModal] = useState(false);
    const windowUrl = baseUrl.replace('/api/v1','');

    useEffect(() => {
        if (Object.keys(selectedItem).length > 0) {
            setShowUpdateItemModal(true);
        }
    }, [selectedItem]);

    useEffect(() => {
        if (!showUpdateItemModal) {
            setSelectedItem({});
        }
    }, [showUpdateItemModal]);

    const addItem = async (item) => { 
        const response = await postData(baseUrl, item);
        if (response.status !== 201 && response.status !== 200) {
            alert('Failed to add item');
        } else {
            setData();
        }
    }

    const deleteItem = async (item) => { 
        const response = await deleteData(`${baseUrl}/${item.id}`);
        if (response.status !== 201 && response.status !== 200) {
            alert('Failed to delete item');
        } else {
            setData();
        }
    }

    const updateItem = async (item) => { 
        const response = await putData(`${baseUrl}/${item.id}`, item);
        if (response.status !== 201 && response.status !== 200) {
            alert('Failed to update item');
        } else {
            setData();
        }
    }

    return (
    <div>
        <ListGroup>
        {data.map((item) => (
            <ListGroup.Item key={item.id} className="d-flex justify-content-between align-items-center">
            <div>
                <h5><Link to={`${windowUrl}/${item.id}`} className='h5-link'>{item.name}</Link></h5>
                {
                     Object.keys(item).filter(element => 
                        element !== 'created_at' && element !== 'id' && !element.includes('_id') && element !== 'name' )
                     .map(field => <p  key={field} className="mb-1">{capitalize(field)}: {item[field]}</p>)
                }
                <small>Created at: {convertdatenotime(item.created_at)}</small>
            </div>
            <Dropdown>
                <Dropdown.Toggle as="button" className="btn p-0">
                </Dropdown.Toggle>
                <Dropdown.Menu>
                <Dropdown.Item onClick={() => setSelectedItem(item)}>Edit</Dropdown.Item>
                <Dropdown.Item onClick={() => deleteItem(item)}>Delete</Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>
            </ListGroup.Item>
        ))}

        {/* Update Item */}
        <ModalItem 
            item={selectedItem} 
            itemFields={fields}
            baseUrl={baseUrl}
            onClickAction={updateItem}
            showModal={showUpdateItemModal}
            setShowModal={setShowUpdateItemModal}
        />

        {/* Add Item */}
        <ModalItem 
            item={{}}
            itemFields={fields}
            baseUrl={baseUrl}
            onClickAction={addItem}
            showModal={showAddItemModal}
            setShowModal={setShowAddItemModal}
        />

        {/* Add new item or upload from the file */}
        <div className='btn-group-custom btn-container'>
        <button className='btn-custom green' onClick={() => setShowAddItemModal(true)}> 
        <BsPlus size={20} className="me-2" />Add New</button>
        </div>
        </ListGroup>

    </div>
    );
};

export default ItemListSpaces;
